export default "__VITE_ASSET__DUADivhX__"